import { useMemo } from 'react'

import { ProjectTranslator } from 'src/translators'
import { useGetProjectQuery } from 'src/types/generated'

type Input = {
  projectId: string
}

export const useGetProject = ({ projectId }: Input) => {
  const { loading, data, error, refetch } = useGetProjectQuery({ variables: { input: projectId } })

  return {
    loading,
    project: useMemo(
      () => (data && data.project ? ProjectTranslator.toDetailEntity(data.project.project) : null),
      [data]
    ),
    error,
    refetch,
  }
}
